import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
export interface RelaunchData {
  changes: number;
}
@Component({
  selector: 'app-relaunch',
  templateUrl: './relaunch.component.html',
  styleUrls: ['./relaunch.component.css']
})
export class RelaunchComponent implements OnInit {

  title = 'Añada un comentario';
  description = 'Para poder relanzar la tarea, es necesario un comentario indicando el motivo';
  placeholder = 'Añada un comentario...';
  comments: string;
  characteristics: CharacteristicsObject;

  constructor(public dialogRef: MatDialogRef<RelaunchComponent>, @Inject(MAT_DIALOG_DATA) public data: CharacteristicsObject) {
  }

  ngOnInit() {
    this.characteristics = this.data;
  }

  public commentsEvent($event) {
    this.comments = $event;
  }
}
